import {
  Building2,
  Heart,
  LifeBuoy,
  Package,
  Settings,
  Shield,
  ShoppingBag,
  type LucideIcon,
} from "@/components/icons";
import { settingsHref } from "@shared/routing/settings-path";

export interface AccountMenuLink {
  label: string;
  href: string;
  icon: LucideIcon;
}

export const ACCOUNT_WORK_LINKS: AccountMenuLink[] = [
  { label: "My purchases", href: "/dashboard/orders", icon: ShoppingBag },
  { label: "My listings", href: "/dashboard/inventory", icon: Package },
  { label: "Saved", href: "/dashboard/saved", icon: Heart },
  { label: "Company", href: settingsHref("company"), icon: Building2 },
];

export const ADMIN_PANEL_LINK: AccountMenuLink = {
  label: "Admin panel",
  href: "/admin",
  icon: Shield,
};

export const ACCOUNT_SUPPORT_LINKS: AccountMenuLink[] = [
  { label: "Settings", href: settingsHref("profile"), icon: Settings },
  { label: "Help", href: "/dashboard/support", icon: LifeBuoy },
];

export function accountMenuGroups(isAdmin: boolean): AccountMenuLink[][] {
  return [
    ACCOUNT_WORK_LINKS,
    isAdmin ? [ADMIN_PANEL_LINK, ...ACCOUNT_SUPPORT_LINKS] : ACCOUNT_SUPPORT_LINKS,
  ];
}
